import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

export type ExcelColumn = { value: string; description: string };

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  public exportToExcel(
    columns: ExcelColumn[],
    data: any[],
    fileName = 'reporte',
    sheetName = 'Hoja1',
  ): void {
    const rows = data.map((row) =>
      columns.reduce<Record<string, unknown>>((acc, column) => {
        acc[column.description] = row[column.value] ?? '';
        return acc;
      }, {}),
    );

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  }
}
